import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { SummaryInformationCard } from 'app/components/summary-information-card';
import { i18n } from 'app/i18n';
import { selectSelectedServiceLocationOrThrow, selectShoppingCartOrThrow } from 'app/pages/order/redux/order-selector';
import { DeliveryStaticData } from 'app/static-data/delivery-static-data';
import { CurrencyUtils } from 'app/utils/currency-utils';
import { DeliveryInformationTransporter } from 'app/pages/order/summary/delivery-information/delivery-information-transporter';
import { SummaryInformationRow } from 'app/components/summary-information-row';
import { OrderInformationUtils } from 'app/pages/order/utils/order-information-utils';

export const DeliveryInformationCard: FunctionComponent = () => {
    const serviceLocation = useSelector(selectSelectedServiceLocationOrThrow);
    const shoppingCart = useSelector(selectShoppingCartOrThrow);
    const { homeGatewayUpgrade } = shoppingCart;

    return (
        <SummaryInformationCard
            title={i18n.page.summary.deliveryInformation.title}
            content={
                <>
                    <SummaryInformationRow
                        label={i18n.page.summary.deliveryInformation.deliveryAddress}
                        value={OrderInformationUtils.getShortAddress(serviceLocation)}
                        isValueSensitive={true}
                    />
                    {/* FIXME: Add delivery information back when CLO-6100 is fixed*/}
                    {!homeGatewayUpgrade && <DeliveryInformationTransporter />}
                </>
            }
            totalPrices={[
                {
                    label: i18n.page.summary.deliveryInformation.summaryPrice,
                    value: CurrencyUtils.formatPriceWithSuffix(DeliveryStaticData.DELIVERY_PRICE),
                },
            ]}
        />
    );
};
